import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import classNames from 'classnames';
import _ from 'lodash';

class AddFileButton extends Component {
  constructor(props) {
    super(props);

    this.onDrop = this.onDrop.bind(this);
  }

  onDrop(files) {
    if (!_.isEmpty(files)) {
      this.props.onDrop(files);
    }
  }

  render() {
    const { accept, className, children, multiple } = this.props;

    return (
      <Dropzone accept={accept} multiple={multiple} onDrop={this.onDrop}>
        {({ getRootProps, getInputProps, isDragActive }) => (
          <div {...getRootProps()} className={classNames(className, { hovering: isDragActive })}>
            <input {...getInputProps()} />
            {children}
          </div>
        )}
      </Dropzone>
    );
  }
}

AddFileButton.propTypes = {
  accept: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  multiple: PropTypes.bool,
  onDrop: PropTypes.func.isRequired,
};

AddFileButton.defaultProps = {
  accept: '',
  children: 'Add File',
  className: 'btn btn-link',
  multiple: true,
};

export default AddFileButton;
